<template>
  <div class="documentList-h">
    <div class="documentContent" style="padding-top: 0">
      <div class="bbbb"></div>
      <div class="inner">
        <div class="documentInner">
          <div class="documentListContent">
            <div class="item" v-for="(item,index) in m" @click="item.isShow = !item.isShow">
              <div class="left" :class="{bg:item.isShow}">
              </div>
              <div class="right">
                <p class="t">
                  {{item.question}}
                </p>
                <p class="content" v-show="item.isShow">
                  {{item.answer}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        m:[
        ]
      }
    },
    methods: {
    },
    created(){
      let _this = this;
      _this.ajpost('/api/system/findHelpList',{},function (data) {
        let datas = JSON.parse(JSON.stringify(data.data));
        datas.forEach((item,index)=>{
          item.isShow = false;
          datas[index] = item
        });
        _this.m = datas
      })
    }
  }
</script>
<style>
  @import "../../assets/less/help.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/help.vue